import Login from './Login.vue'

export { Login };



// WEBPACK FOOTER //
// ./src/pages/login/index.js